import type { FC } from 'react'

export const PageHeadTertiaryAssets: FC = () => {
	return (
		<div className="w-full pointer-events-none" aria-hidden="true">
			{/* Mobile Assets */}
			<div className="relative flex w-full h-15 tablet-p:hidden">
				{/* Left asset - light blue */}
				<div className="flex-1 h-full">
					<div className="h-12 w-full bg-blue-tint-10" />
				</div>
				{/* Right asset - dark blue */}
				<svg
					viewBox="0 0 129 60"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="h-full w-auto"
				>
					<path
						d="M129 60H105.783C97.2988 60 89.1622 56.6311 83.1616 50.6338L46.1655 13.6587C41.1236 8.61962 44.6924 2.4719e-06 51.8207 0H129V60Z"
						fill="#005EB8"
					/>
					<path
						d="M3.26123 0.000488281C11.7505 0.000524884 19.892 3.37385 25.8936 9.37793L50.8491 34.3442C55.8871 39.3844 52.3177 47.9999 45.1914 48L0 47.9995V0L3.26123 0.000488281Z"
						fill="#E5EEF7"
					/>
				</svg>
			</div>
			{/* Tablet and desktop Assets */}
			<div className="hidden w-full tablet-p:flex h-22.5 desktop:h-30">
				<div className="flex-1 h-full">
					<div className="h-18 desktop:h-24 w-full bg-blue-tint-10" />
				</div>
				{/* Right asset - dark blue */}
				<svg
					viewBox="0 0 339 120"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="h-full w-auto"
				>
					<path
						d="M339 120H211.565C194.598 120 178.324 113.262 166.323 101.268L92.3309 27.3174C82.2471 17.2392 89.3848 4.94379e-06 103.641 0H339V120Z"
						fill="#005EB8"
					/>
					<path
						d="M6.52246 0.000976562C23.5009 0.00104977 39.7841 6.74771 51.7871 18.7559L101.698 68.6885C111.774 78.7688 104.635 95.9997 90.3828 96L0 95.999V0L6.52246 0.000976562Z"
						fill="#E5EEF7"
					/>
				</svg>
			</div>
		</div>
	)
}
